<template>
  <v-form>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12>
          <v-menu
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="stocktakingMonth"
                label="棚卸年月"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="monthForPicker"
              type="month"
              @input="menu = false"
              locale="jp-ja"
              no-title
              scrollable
              @change="onChangeMonth()"
            >
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex>
          <v-select
            label="期間選択"
            v-model="selectedWeek"
            :items="weekItems"
            item-text="dispWeek"
            item-value="weekNumber"
            @change="bindConfirmData()"
          ></v-select>
        </v-flex>
      </v-layout>

      <div style="height: 35px;"></div>

      <v-card>
        <v-container>
          <v-card-title class="title-highlight">
            倉庫
          </v-card-title>

          <v-layout row wrap reverse>
            <v-flex sm2 align-self-center>
              <v-btn block color="info" @click="getWarehouseStocktaking()">
                <v-icon left>update</v-icon>{{ $t('update-btn') }}
              </v-btn>
            </v-flex>

            <div style="width: 10px;"></div>

            <v-flex sm2 align-self-center>
              <v-btn
                block
                color="warning"
                v-bind:disabled="!dispApplyBtn"
                @click="confirmStock()"
                :loading="confirmLoading"
              >
                <v-icon left>save</v-icon>商品在庫に反映する
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout row wrap align-center>
            <div style="height: 35px;"></div>

            <v-data-table
              :headers="warehouseHeaders"
              :items="warehouses"
              hide-actions
              class="elevation-1"
              :custom-sort="customSort"
              style="width: 100%; margin: 15px 0 0;"
              :no-data-text="$t('noTableDataAvailable')"
              :loading="storeDataLoading"
            >
              <template slot="headerCell" slot-scope="props">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <span v-on="on">{{ props.header.text }}</span>
                  </template>
                  <span>{{ props.header.text }}</span>
                </v-tooltip>
              </template>
              <template v-slot:items="props">
                <tr
                  v-bind:class="{
                    'active-class-name': props.item.createdUser
                  }"
                >
                  <td
                    class="text-xs-left"
                    @click="forwardStockManagementDetail(props.item)"
                  >
                    {{ props.item.warehouseName }}
                  </td>
                  <td
                    class="text-xs-left"
                    @click="forwardStockManagementDetail(props.item)"
                  >
                    {{ props.item.createdAt }}
                  </td>
                  <td
                    class="text-xs-left"
                    @click="forwardStockManagementDetail(props.item)"
                  >
                    {{ props.item.createdUser }}
                  </td>
                  <td class="text-xs-left">
                    <v-flex xs3 sm3>
                      <v-btn
                        block
                        color="error"
                        dark
                        v-bind:disabled="!props.item.createdAt"
                        @click="deleteDialog(props.item)"
                      >
                        <v-icon dark left>delete_forever</v-icon>{{ $t('delete-btn') }}
                      </v-btn>
                    </v-flex>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-layout>

          <div style="height: 25px;"></div>

          <!-- 버튼 영역 -->
          <div class="footer-btns">
            <v-btn block color="#4C728A" dark :to="{ name: 'admin/new-admin-menu' }">
              <v-icon color="black" left>home</v-icon>{{ $t('home-btn') }}
            </v-btn>
            <v-btn block color="info" dark @click="downloadCsv()">
              <v-icon dark left>get_app</v-icon>棚卸データダウンロード
            </v-btn>
          </div>
        </v-container>
      </v-card>
    </v-container>

    <v-dialog max-width="300px" v-model="dispDeleteDialog">
      <!-- v-model="dialog1" -->
      <v-card>
        <v-container>
          <v-card-title>
            <span style="margin: 0 auto 0;">{{ $t('delete-btn') }}しますか</span>
          </v-card-title>
          <v-layout row wrap style="margin-bottom:20px;">
            <v-flex xs12 sm12>
              <v-btn color="error" text @click="deleteStocktaking()"
                >{{ $t('delete-btn') }}</v-btn
              >
              <v-btn text @click.stop="dispDeleteDialog = false">{{ $t('back-btn') }}</v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
    </v-dialog>
  </v-form>
</template>

<script>
import moment from 'moment-timezone'
import ServerApiCallService from '@/services/ServerApiCallService.js'
import axios from 'axios'

export default {
  created() {
    console.log('created')

    ServerApiCallService.setAppJs(this.$parent.$parent.$parent)

    console.log(this.stocktakingMonth)
    if (!this.stocktakingMonth) {
      this.$store.commit(
        'SET_WAREHOUSE_STOCKTAING_MONTH',
        moment().format('YYYY/MM')
      )
    }

    this.getWarehouseStocktaking()
  },
  computed: {
    stocktakingMonth: {
      get() {
        return this.$store.state.adminSession.warehouseStocktakingMonth
      },
      set(value) {
        this.$store.commit('SET_WAREHOUSE_STOCKTAING_MONTH', value)
      }
    },
    selectedWeek: {
      get() {
        return this.$store.state.adminSession.selectedWeekNumber
      },
      set(value) {
        this.$store.commit('SET_SELECTED_WEEK_NUMBER', value)
      }
    }
  },
  methods: {
    getWarehouseStocktaking() {
      console.log('getWarehouseStocktaking')
      let thisObj = this

      this.storeDataLoading = true

      thisObj.weekItems = []

      // 選択した月のweek numberを取得
      var startWeekNumberInMonth = moment(this.stocktakingMonth, 'YYYY/MM')
        .startOf('month')
        .week()

      var endWeekNumberInMonth = moment(this.stocktakingMonth, 'YYYY/MM')
        .endOf('month')
        .week()

      // 年末の場合、week numberを修正
      if ('12' === moment(this.stocktakingMonth, 'YYYY/MM').format('MM')) {
        endWeekNumberInMonth = moment().weeksInYear()
      }

      let request = {
        stocktakingYear: moment(this.stocktakingMonth, 'YYYY/MM').format(
          'YYYY'
        ),
        startWeekNumberInMonth: startWeekNumberInMonth,
        endWeekNumberInMonth: endWeekNumberInMonth
      }

      ServerApiCallService.getWarehouseStocktaking(request)
        .then(response => {
          var nowWeekNumber = moment().week()

          response.data.confirmItems.forEach(item => {
            var weekItemsTemp = {
              dispWeek:
                moment()
                  .startOf('week')
                  .week(item.weekNumber)
                  .format('MM/DD') +
                ' - ' +
                moment()
                  .endOf('week')
                  .week(item.weekNumber)
                  .format('MM/DD'),
              weekNumber: item.weekNumber
            }
            thisObj.weekItems.push(weekItemsTemp)

            if (item.weekNumber === nowWeekNumber) {
              thisObj.selectedWeek = item.weekNumber
            }
          })

          this.warehouses = response.data.warehouses

          this.confirmItems = response.data.confirmItems

          this.weekItems.sort(function(a, b) {
            if (a.weekNumber > b.weekNumber) return 1
            if (a.weekNumber < b.weekNumber) return -1
            return 0
          })

          // 確定データを取り込む処理
          this.bindConfirmData()

          this.storeDataLoading = false
        })
        .catch(error => {
          console.log('There was an error:', error.response)
        })
    },
    bindConfirmData() {
      console.log('bindConfirmData')
      let thisObj = this

      this.$store.commit('SET_SELECTED_WEEK_NUMBER', this.selectedWeek)

      thisObj.dispApplyBtn = false

      // 表示データの初期化
      thisObj.warehouses.forEach(warehouse => {
        warehouse.createdAt = ''
        warehouse.createdUser = ''
      })

      thisObj.confirmItems.forEach(item => {
        if (thisObj.selectedWeek === item.weekNumber) {
          thisObj.warehouses.forEach(warehouse => {
            if (item.warehouseId === warehouse.warehouseId) {
              warehouse.createdAt = moment(item.createdAt).format('MM/DD HH:mm')
              warehouse.createdUser = item.createdUser
            }
          })

          // 「商品在庫に反映する」ボタンの表示
          if ('0' === item.status) {
            thisObj.dispApplyBtn = true
          }
        }
      })
    },
    onChangeMonth() {
      console.log('onChangeMonth')

      this.$store.commit(
        'SET_WAREHOUSE_STOCKTAING_MONTH',
        this.monthForPicker.replace(/-/g, '/')
      )

      this.$store.commit('SET_SELECTED_WEEK_NUMBER', '')

      this.getWarehouseStocktaking()
    },
    deleteDialog(selectedStocktaking) {
      console.log('deleteDialog')
      this.selectedStocktaking = selectedStocktaking
      this.dispDeleteDialog = true
    },
    deleteStocktaking() {
      console.log('deleteStocktaking')

      let request = {
        stocktakingYear: moment(this.stocktakingMonth, 'YYYY/MM').format(
          'YYYY'
        ),
        warehouseId: this.selectedStocktaking.warehouseId,
        weekNumber: this.selectedWeek
      }

      ServerApiCallService.deleteWarehouseStocktaking(request)
        .then(response => {
          this.dispDeleteDialog = false
          this.getWarehouseStocktaking()
        })
        .catch(error => {
          console.log('There was an error:', error.response)
          this.getWarehouseStocktaking()
        })
    },
    confirmStock() {
      console.log('confirmStock')

      this.confirmLoading = true

      let request = {
        stocktakingYear: moment(this.stocktakingMonth, 'YYYY/MM').format(
          'YYYY'
        ),
        weekNumber: this.selectedWeek
      }

      ServerApiCallService.confirmWarehouseStocktaking(request)
        .then(response => {
          this.confirmLoading = false
          this.getWarehouseStocktaking()
        })
        .catch(error => {
          this.confirmLoading = false
          this.getWarehouseStocktaking()
          console.log('There was an error:', error.response)
        })
    },
    forwardStockManagementDetail(selectedWarehouse) {
      console.log('forwardStockManagementDetail')

      if (selectedWarehouse.createdAt) {
        this.$router.push({
          name: 'admin/WarehouseStockManagementDetail',
          params: {
            warehouseId: selectedWarehouse.warehouseId,
            weekNumber: this.selectedWeek,
            stocktakingYear: moment(this.stocktakingMonth, 'YYYY/MM').format(
              'YYYY'
            )
          }
        })
      }
    },
    downloadCsv() {
      console.log('downloadCsv')
      console.log(this.selectedWeek)

      if (!this.selectedWeek) {
        this.$parent.$parent.$parent.showErrorDialog(
          '棚卸期間を選択してください'
        )
        return
      }

      let request = {
        stocktakingYear: moment(this.stocktakingMonth, 'YYYY/MM').format(
          'YYYY'
        ),
        weekNumber: this.selectedWeek
      }

      console.log('request body' + JSON.stringify(request))

      axios
        .create({
          baseURL: ServerApiCallService.getServerUrl(),
          withCredentials: false, // This is the default
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=utf-8',
            accessToken: window.localStorage.getItem('accessToken')
          }
        })
        .post('/admin/warehouse-stocktaking-download', request, {
          responseType: 'blob'
        })
        .then(({ data }) => {
          let blob = new Blob([data], { type: 'text/csv' })
          let link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = '倉庫棚卸在庫.csv'
          link.click()
        })
    },
    customSort(items) {
      items.sort((a, b) => {
        if (a.warehouseId > b.warehouseId) return 1
        if (a.warehouseId < b.warehouseId) return -1
        return 0
      })
      return items
    }
  },
  data() {
    return {
      confirmLoading: false,
      confirmItems: [],
      weekItems: [],
      dispApplyBtn: false,
      selectedStocktaking: '',
      dispDeleteDialog: false,
      storeDataLoading: false,
      disableStocktakingDate: true,
      menu: false,
      stocktakingMenu: false,
      monthForPicker: '',
      dateForPicker: '',
      selectSupplier: [],
      suppliers: [],
      warehouseHeaders: [
        {
          text: '倉庫名',
          align: 'left',
          value: 'warehouseName',
          sortable: false,
          fixed: false
        },
        {
          text: '登録日',
          align: 'left',
          value: 'status',
          sortable: false,
          fixed: false
        },
        {
          text: '登録者',
          align: 'left',
          value: 'createdUser',
          sortable: false,
          fixed: false
        },
        {
          text: '',
          align: 'left',
          sortable: false,
          value: 'delete',
          width: '20px'
        }
      ],
      warehouses: [],
      stores: []
    }
  }
}
</script>
<style>
.active-class-name {
  background-color: #d5ffc4;
}
.title-highlight {
  font-size: 20px;          /* 🔹 기본 타이틀보다 크게 */
  font-weight: bold;        /* 🔹 굵게 */
  color: #2c3e50;           /* 🔹 진한 남색 계열 */
  /*border-left: 5px solid #4C728A; /* 🔹 왼쪽에 포인트 라인 */
  padding-left: 10px;       /* 🔹 라인과 글자 사이 간격 */
  margin-bottom: 10px;      /* 🔹 아래 여백 */
}
.footer-btns {
  position: sticky;         /* 스크롤해도 하단 고정 */
  bottom: 0;                /* 컨테이너의 맨 아래 */
  display: flex;
  justify-content: space-between; /* 버튼 사이 일정 간격 */
  gap: 8px;                 /* 버튼들 사이 여백 */
  width: 100%;              /* 테이블 폭과 동일 */
  background: white;        /* 버튼 뒤 배경 */
  padding: 10px 0;          /* 위아래 여백 */
  z-index: 1000;
}
.footer-btns .v-btn {
  flex: 1;                  /* 버튼들이 같은 폭 */
}
</style>
